import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4();
  return `SB_${uuid.replaceAll('-', '_')}`;
};
